<template>
  <app-board v-if="amReady">
    <h4 class="p-3">Customers</h4>
    <el-dialog :visible.sync="customerRatesBoardDialog" title="" top="2vh" width="90%" @close="reloadList">
      <voipCustomerRates :customerUserId="customerData.user_id" :userUsingPrivateRate="userUsingPrivateRate" :userRateStatus="userRateStatus" :customerDisplayName="customerData.display_name" v-if="customerRatesBoardDialog"></voipCustomerRates>
    </el-dialog>

    <div class="row pl-3 pr-3">
      <!--<div class="col-12 col-md-6">
        <dg-text-field
            :field_span="19"
            :label_span="24"
            :liveUpdate="true"
            @amUpdated="userSearchUpdated"
            field_mark=""
            placeholder="search here"></dg-text-field>
      </div>-->
      <div class="col-12 col-md-6">
        <pagination
            :currentPage="currentPage"
            :margin-pages="2"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            :page-range="4"
            paginateClass=""></pagination>
      </div>
    </div>

    <app-ag-grid :agGrid="agGrid"></app-ag-grid>
  </app-board>
</template>

<script>
import Vue from 'vue'
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'
import {mapActions} from "vuex";
import usingPrivateRate from './ag-grid/PrivateRate'
import hasLcrModule from './ag-grid/hasLcrModule'
import openRates from './ag-grid/OpenRates'

export default {
  components: {
    pagination: () => import('@/components/pagination/View.vue'),
    voipCustomerRates: () => import('@/modules/voip-customer-rate/list/page/View'),
  },
  data() {
    return {
      userUsingPrivateRate: null,
      userRateStatus: null,
      customerRatesBoardDialog: false,
      userSearch: '',
      userSearchTimeOut: null,
      amReady: false,
      module: {
        ...module
      },
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            params.api.sizeColumnsToFit()
          }
        },
        columnDefs: [
          {
            field: 'display_name',
            headerName: 'Customer',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'using_private_rate',
            headerName: 'Private Rate',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            cellRendererFramework: Vue.extend(usingPrivateRate),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          },
          {
            field: 'has_lcr',
            headerName: 'LCR Feature',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            cellRendererFramework: Vue.extend(hasLcrModule),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          },
          {
            field: 'current_rates_counter',
            headerName: 'Private Rates Count',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            width: 80,
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: Vue.extend(openRates),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }
        ],
        rowData: []
      }
    };
  },
  beforeMount() {
    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
  },
  methods: {
    reloadList () {
      this.getEntityListData(this.currentPage)
    },
    openCustomerRatesBoard (params) {
      let data = params.data
      this.rowToEdit = params.rowIndex
      this.customerData = data
      this.userRateStatus = (data.using_private_rate) ? '<span class="voip-call-test-status pending p-2">Private Rate</span>' : '<span class="voip-call-test-status awaiting-action p-2">Default Rate</span>'
      this.userUsingPrivateRate = data.using_private_rate
      this.customerRatesBoardDialog = true
    },
    ...mapActions('user-customer-features-api', {
      updateCustomerFields: 'update'
    }),
    setUserHasLcrModule (params) {
      let data = {
        user_id: params.userId,
        modules: [
          'voip-lcr-menu',
          'voip-lcr-top-destinations'
        ]
      }
      if (params.value) {
        this.giveUserModules({data})
      } else {
        this.removeUserModules({data})
      }
    },
    ...mapActions('user-api', {
      giveUserModules: 'giveUserModules',
      removeUserModules: 'removeUserModules'
    }),
    setUserUsingPrivateRate(params) {
      let apiData = params.apiData
      let rowData = params.rowData

      let data = {
        using_private_rate: (apiData.value == true)? 1 : 0,
        user_id:  apiData.userId
      }

      /*this.agGrid.rowData[this.rowToEdit] = rowData;
      this.refreshGrid();*/

      this.updateCustomerFields({data})
    },
    getEntityListData(page) {
      this.getEntityList({page: page, search: this.userSearch}).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.agGrid.rowData = response.rows
      this.recordsCounter = response.count
      this.amReady = true
    },
    userSearchUpdated(field) {
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    ...mapActions('voip-customer-api', {getEntityList: 'list'}),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      $router.push({name: 'module->voip-customer->list->page', params: {listPage: page}})
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'module->voip-customer->view', params: { id: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
    },
    removeAction(params) {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
